import { render } from "./AddPatientPage.vue?vue&type=template&id=47f78882&ts=true"
import script from "./AddPatientPage.vue?vue&type=script&lang=ts"
export * from "./AddPatientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__